// extracted by mini-css-extract-plugin
export default {"slow":"SlowCircularProgress_slow__H4l1g"};